<script setup lang="ts">
import { onServerPrefetch, useSSRContext, watch, onBeforeMount, computed } from 'vue';
import { useRoute } from 'vue-router'
import { useAppStore } from '@/home/stores/app';

export interface ItemType {
  path: string,
  label: string
}

const props = defineProps({
  itemList: {
    type: Array<ItemType>,
    default: () => [],
  },
  defaultTitle: {
    type: String,
    default: '',
  },
});

const appStore = useAppStore();
const route = useRoute()

// 在路由变化时更新 selectedIndex
const selectedIndex = computed(() => props.itemList.findIndex((item) => item.path === route.path));

const getTitle = () => props.defaultTitle ? `${props.itemList[selectedIndex.value].label} - ${props.defaultTitle}` : props.itemList[selectedIndex.value].label;

onBeforeMount(() => {
  appStore.setTitle(getTitle());
});

onServerPrefetch(async () => {
  const ctx = useSSRContext() as Record<string, any>;
  ctx.title = getTitle()
});

watch(() => route.path, () => {
  appStore.setTitle(getTitle());
});
</script>

<template>
  <div class="container mx-auto">
    <div class="relative mb-48 mt-45 w-full flex items-center justify-between">
      <div
        v-for="(item, index) in props.itemList"
        :key="item.path"
        class="box-border w-20% px-10"
      >
        <RouterLink
          class="mb-16 block items-center break-words text-center text-balance text-24 leading-36 no-underline focus-visible:outline-unset"
          :class="[selectedIndex === index ? 'text-[#1180FF]' : 'text-[#2D2D2D]']"
          :to="item.path"
        >
          {{ item.label }}
        </RouterLink>
      </div>

      <div
        class="absolute bottom-0 left-0 h-2 w-20% bg-[#1180ff] transition-transform duration-300"
        :style="{ transform: `translateX(${selectedIndex * 100}%)` }"
      >
      </div>
    </div>

    <RouterView />
  </div>
</template>
